import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Nav from "../Home/Nav/Nav";
import PageTop from "../../common/PageTop/PageTop";
import Footer from "../../common/Footer/Footer";
import Client from "../../common/axiosApi";
import IndServBody from "./IndServBody";
import aboutimage from '../../../assets/images/ogser.jpg'

const IndividualService = () => {
  const { id } = useParams();
  console.log(id);

  const [individual, setIndividual] = useState();

  const getIndService = async () => {
    try {
      const serviceIndResponse = await Client.get("/service/getInd", {
        params: { id },
      });
      console.log(serviceIndResponse.data.getInd);

      if (serviceIndResponse.status === 200) {
        const services = serviceIndResponse.data.getInd;
        setIndividual(services);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getIndService();
  }, [id]);

  return (
    <>
      <Nav />
      <PageTop title={individual && individual.service} image={aboutimage}/>
      <IndServBody individual={individual}/>
      <Footer />
    </>
  );
};

export default IndividualService;
